import React from 'react';
import '../styles/Global.css';

import Header from './Header';
import Footer from './Footer';

const Careers: React.FC = () => (
        <div className="page-container">
            <Header />  
            <main className="page-content">
                <section className="careers-section">
                    <h1>Careers at Consphic</h1>
                    <p>Join our innovative team and help shape the future!</p>
                    <div className="job-listings">
                        <div className="job-card">
                            <h2>Frontend Developer</h2>
                            <p><strong>Location:</strong> Remote / Bangalore</p>
                            <p>
                                We are looking for a skilled React developer with a passion for building beautiful and performant web applications.
                            </p>
                            <ul>
                                <li>2+ years experience with React.js</li>
                                <li>Strong knowledge of HTML, CSS, JavaScript</li>
                                <li>Experience with REST APIs</li>
                            </ul>
                            <button className="submit-button">Apply Now</button>
                        </div>
                        <div className="job-card">
                            <h2>UI/UX Designer</h2>
                            <p><strong>Location:</strong> Remote / Mumbai</p>
                            <p>
                                Seeking a creative UI/UX Designer to craft engaging user experiences for our digital products.
                            </p>
                            <ul>
                                <li>Experience with Figma or Adobe XD</li>
                                <li>Strong portfolio of design projects</li>
                                <li>Excellent communication skills</li>
                            </ul>
                            <button className="submit-button">Apply Now</button>
                        </div>
                    </div>
                </section>
            </main>
            <Footer/>
        </div>
    );

export default Careers;